export default __webpack_public_path__ + "static/media/d_wdt_c_4.33299b5d.mp3";